const E = {
  settingColumnHeaders: 'Drag and drop the column headers in the way you would like them displayed in your window. You can select as many as you would like. You many need to side swipe on your page if you do not see the columns you have selected.',
};

const F = {
  settingColumnHeaders: 'Faites glisser les en-têtes de colonnes de la manière que vous souhaitez les afficher dans votre fenêtre. Vous pouvez en sélectionner autant que vous le souhaitez. Vous devrez peut-être faire glisser votre doigt sur la page si vous ne voyez pas les colonnes que vous avez sélectionnées.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/tutorials/editColumns.js